import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { graphql, withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import Immutable from 'immutable';
import moment from 'moment';
import { MentionsInput, Mention } from 'react-mentions';
import debounce from 'lodash/debounce';
import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import { avatarSelector } from '../../reducers/avatars';
import Avatar from '../Avatar';
import Loading from '../Loading';
import NoElements from '../states/NoElements';
import Linkify from 'react-linkify';
import defaultStyle from './defaultStyle';

// re = /(\[(.+?)\]\((.+?):(.+?)\))/g
// re.exec(str)

// https://codesandbox.io/s/0q244nqoyl

const getHighlightColor = type => {
  switch (type) {
    case 'user':
      return 'tomato';
    case 'tag':
      return 'lightblue';
    case 'element':
      return 'magenta';
  }
};

class CommentMentionElement extends React.Component {
  render() {
    const { tag, projectId } = this.props;

    return (
      <span
        key={tag.index}
        style={{
          backgroundColor: getHighlightColor(tag.type),
          color: '#fff',
          paddingLeft: 4,
          paddingRight: 4,
        }}
      >
        <a
          style={{ color: '#fff' }}
          target="_blank"
          href={`/project/${projectId}/element/${tag.id}`}
        >
          {tag.display}
        </a>
      </span>
    );
  }
}

class CommentMentionUser extends React.Component {
  render() {
    const { tag } = this.props;

    return (
      <span
        key={tag.index}
        style={{
          backgroundColor: getHighlightColor(tag.type),
          color: '#fff',
          paddingLeft: 4,
          paddingRight: 4,
        }}
      >
        {tag.display}
      </span>
    );
  }
}

class CommentMentionTag extends React.Component {
  render() {
    const { tag } = this.props;

    return (
      <span
        key={tag.index}
        style={{
          backgroundColor: getHighlightColor(tag.type),
          color: '#fff',
          paddingLeft: 4,
          paddingRight: 4,
        }}
      >
        {tag.display}
      </span>
    );
  }
}

class Comment extends React.Component {
  render() {
    const { comment } = this.props;
    const message = comment.comment;
    console.log('comment', comment);
    const tags = comment.comment_objects;
    console.log('tags', tags);
    // if (!message) return <div />;
    const chunks = [];

    // hi @matt this is a #cool tag
    let i = 0;
    let c = 0;

    while (i < tags.length) {
      const tag = tags[i];
      const substr = message.substring(c, tag.index);
      chunks.push(substr);

      switch (tag.type) {
        case 'element':
          chunks.push(
            <CommentMentionElement tag={tag} projectId={comment.project_id} />,
          );
          break;
        case 'user':
          chunks.push(
            <CommentMentionUser tag={tag} projectId={comment.project_id} />,
          );
          break;
        case 'tag':
          chunks.push(
            <CommentMentionTag tag={tag} projectId={comment.project_id} />,
          );
          break;
        default:
          break;
      }

      // chunks.push(
      //   <span
      //     key={tag.index}
      //     style={{
      //       backgroundColor: getHighlightColor(tag.type),
      //       color: '#fff',
      //       paddingLeft: 4,
      //       paddingRight: 4,
      //     }}
      //   >
      //     {/* {tag.type === 'user' ? '@' : '#'} */}
      //     {tag.display}
      //   </span>,
      // );

      c = tag.index + tag.display.length;
      i++;
    }

    chunks.push(message.substring(c));

    // console.log('chunks', chunks);

    return (
      <div
        style={{
          background: '#fdfdfd',
          padding: '10px 15px',
          borderBottom: '1px solid #ddd',
        }}
      >
        <div style={{ paddingBottom: '10px' }}>
          <div style={{ display: 'inline-block' }}>
            <Avatar
              className="mr-1"
              avatar={Immutable.fromJS(comment.user.avatar)}
              user={Immutable.fromJS(comment.user)}
              width="37"
              height="37"
              rounded
            />
          </div>
          {comment.user.first_name} {comment.user.last_name}{' '}
          <small>{moment(comment.created_at).fromNow()}</small>
        </div>
        <div>
          <Linkify
            properties={{
              target: '_blank',
            }}
          >
            {chunks}
          </Linkify>
        </div>
      </div>
    );
  }
}

const users = [
  { id: 1, display: 'matt dido' },
  { id: 2, display: 'jeff' },
  { id: 3, display: 'thanh' },
];

const tags = [
  { id: 1, display: 'cool' },
  { id: 2, display: 'woot' },
  { id: 3, display: 'yay' },
];

const elements = [
  { id: 1, display: 'element 1' },
  { id: 2, display: 'element 2' },
  { id: 3, display: 'element 3' },
];

const convert = meta =>
  meta.map(m => ({
    display: m.display,
    length: m.display.length,
    offset: m.plainTextIndex,
    type: m.type,
  }));

const createCommentMutation = gql`
  mutation createComment(
    $commentableId: String
    $commentableType: String
    $comment: String
  ) {
    createComment(
      commentableId: $commentableId
      commentableType: $commentableType
      comment: $comment
    ) {
      id
      project_id
      comment
      comment_objects
      created_at
      user {
        id
        username
        first_name
        last_name
        avatar {
          id
          path
        }
      }
    }
  }
`;

const ElementContainerSelector = immutableCreatorSelector(
  [avatarSelector],
  avatar => {
    return {
      avatar,
    };
  },
);

const CreateCommentButton = connect(ElementContainerSelector)(
  graphql(createCommentMutation)(
    ({
      id,
      type,
      projectId,
      comment,
      commentPlain,
      currentUser,
      clearState,
      mutate,
      avatar,
      commentMeta,
    }) => (
      <button
        className="btn btn-primary"
        onClick={() => {
          mutate({
            variables: {
              commentableId: id,
              commentableType: type,
              comment,
              meta: commentMeta,
            },
            // updateQueries: {
            //   Comments: (prev, { mutationResult }) => {
            //     const newComment = mutationResult.data.createComment;
            //     return { ...prev, comments: prev.comments.concat(newComment) };
            //   },
            // },
            update: (proxy, { data: { createComment } }) => {
              const data = proxy.readQuery({
                query,
                variables: {
                  id,
                  type,
                  projectId,
                },
              });

              data.comments.push(createComment);
              proxy.writeQuery({
                query,
                variables: { id, type, projectId },
                data,
              });
            },
            optimisticResponse: {
              __typename: 'Mutation',
              createComment: {
                id: '-1000',
                project_id: projectId,
                comment: commentPlain,
                comment_objects: {},
                created_at: new Date().toString(),
                __typename: 'Comment',
                user: {
                  id: currentUser.get('id'),
                  username: '',
                  first_name: currentUser.get('first_name'),
                  last_name: currentUser.get('last_name'),
                  avatar: {
                    id: currentUser.get('avatar_id'),
                    path: avatar ? avatar.get('path') : null,
                    __typename: 'Avatar',
                  },
                  __typename: 'User',
                },
              },
            },
          });

          clearState();
        }}
      >
        <i className="fa fa-check" />
      </button>
    ),
  ),
);

const COMMENT_CREATED_SUBSCRIPTION = gql`
  subscription commentCreated(
    $commentableId: String!
    $commentableType: String!
  ) {
    commentCreated(
      commentableId: $commentableId
      commentableType: $commentableType
    ) {
      id
      project_id
      comment
      comment_objects
      created_at
      user {
        id
        username
        first_name
        last_name
        avatar {
          id
          path
        }
      }
    }
  }
`;

const query = gql`
  query Comments($id: String!, $type: String, $projectId: String) {
    comments(
      commentableId: $id
      commentableType: $type
      projectId: $projectId
    ) {
      id
      project_id
      comment
      comment_objects
      created_at
      user {
        id
        username
        first_name
        last_name
        avatar {
          id
          path
        }
      }
    }
  }
`;

const withData = graphql(query, {
  options: ({ id, type, projectId }) => ({
    variables: {
      id,
      type,
      projectId,
    },
  }),
  props: props => {
    return {
      subscribeToNewComments: currentProps => {
        return props.data.subscribeToMore({
          document: COMMENT_CREATED_SUBSCRIPTION,
          variables: {
            commentableId: currentProps.id,
            commentableType: currentProps.type,
          },
          updateQuery: (prev, { subscriptionData }) => {
            // if (!subscriptionData.data) {
            //   return prev;
            // }
            const newComment = subscriptionData.data.commentCreated;
            return { ...prev, comments: prev.comments.concat(newComment) };
          },
        });
      },
      ...props,
    };
  },
});

@withApollo
@withData
class Comments extends PureComponent {
  state = {
    value: '',
    open: false,
  };

  subscription = null;

  componentWillMount() {
    const { subscribeToNewComments } = this.props;
    this.subscription = subscribeToNewComments(this.props);
  }

  componentWillUnmount() {
    this.subscription();
  }

  componentWillReceiveProps(nextProps) {
    const { subscribeToNewComments } = nextProps;

    if (nextProps.id !== this.props.id) {
      // TODO: Need to kill the old subscription
      this.subscription();
      this.subscription = subscribeToNewComments(nextProps);
    }
  }

  // handleChange = event => {
  //   this.setState({ value: event.target.value });
  // };

  handleChange = (e, value, valueText, mentions) => {
    console.log(value, valueText, mentions);
    const planTextValue = valueText;
    const meta = convert(mentions);
    this.setState({ value, meta, planTextValue });
  };

  handleSubmit = event => {
    event.preventDefault();
  };

  changeOpenState = () => {
    this.setState({
      open: true,
    });
  };

  clearState = () => {
    this.setState({
      open: false,
      value: '',
    });
  };

  fetchUsers = debounce(async (input, cb) => {
    const { client, projectId } = this.props;

    if (!input) {
      return { options: [] };
    }

    client
      .query({
        query: gql`
          query SearchUsers($projectId: String!, $query: String!) {
            searchUsers(projectId: $projectId, query: $query) {
              id
              first_name
              last_name
            }
          }
        `,
        variables: {
          projectId: projectId,
          query: input,
        },
      })
      .then(results => {
        console.log(input, results);
        return results.data.searchUsers.map(r => ({
          id: r.id,
          display: `${r.first_name} ${r.last_name}`,
        }));
      })
      .then(cb);
  }, 500);

  fetchElements = debounce(async (input, cb) => {
    const { client, projectId } = this.props;

    if (!input) {
      return { options: [] };
    }

    client
      .query({
        query: gql`
          query Search($projectId: String!, $query: String!) {
            search(projectId: $projectId, query: $query) {
              id
              name
            }
          }
        `,
        variables: {
          projectId: projectId,
          query: input,
        },
      })
      .then(results => {
        return results.data.search.map(r => ({
          id: r.id,
          display: r.name,
        }));
      })
      .then(cb);
  }, 500);

  render() {
    const {
      id,
      type,
      currentUser,
      projectId,
      // avatar,
      data: { comments, loading },
    } = this.props;
    if (loading) {
      return <Loading loadingMessage="Loading comments..." />;
    }

    if (!comments) {
      return <div>Loading...</div>;
    }

    const displayComments = !comments.length ? (
      <NoElements missingEntity={'comments'} missingType={'comments'} />
    ) : (
      <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px' }}>
        {comments.map((c, i) => <Comment comment={c} key={i} />)}
      </div>
    );

    return (
      <div style={{ marginTop: 20 }}>
        <label
          style={{
            fontFamily: 'Arial, sans-serif',
            fontSize: '14px',
            color: '#707070',
            fontWeight: '700',
          }}
        >
          Comments
        </label>
        <form onSubmit={this.handleSubmit}>
          <MentionsInput
            // className="form-control"
            value={this.state.value}
            onChange={this.handleChange}
            onClick={this.changeOpenState}
            // displayTransform={this.handleDisplayTransform}
            markup="[__display__](__type__:__id__)"
            style={defaultStyle}
            allowSpaceInQuery
          >
            <Mention trigger="@" data={this.fetchUsers} type="user" />
            <Mention trigger="#" data={tags} type="tag" />
            <Mention
              trigger="!"
              data={this.fetchElements}
              type="element"
              // renderSuggestion={(suggestion, search, highlightedDisplay) => (
              //   <div className="user">aaa - {highlightedDisplay}</div>
              // )}
              style={{ backgroundColor: '#d1c4e9' }}
            />
          </MentionsInput>
          {/* <input
            className="form-control"
            type="text"
            value={this.state.value}
            onChange={this.handleChange}
            onClick={this.changeOpenState}
          /> */}
          {this.state.open && (
            <div className="btn-group d-flex justify-content-end">
              <CreateCommentButton
                id={id}
                type={type}
                projectId={projectId}
                comment={this.state.value}
                commentPlain={this.state.planTextValue}
                commentMeta={this.state.meta}
                currentUser={currentUser}
                clearState={this.clearState}
              />
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={this.clearState}
              >
                <i className="fa fa-times" />
              </button>
            </div>
          )}
        </form>
        {displayComments}
      </div>
    );
  }
}

export default Comments;



// WEBPACK FOOTER //
// ./src/components/Comments/index.js